import React from 'react';
import {motion} from 'framer-motion';
import useMediaQuery from '../hooks/useMediaQuery';

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundColor: 'white',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const containerStyleMobile = {
  position: 'absolute',
  top: '33%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '25%',
  backgroundColor: 'white',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const circleStyle = {
  display: 'block',
  width: '14rem',
  height: '14rem',
  border: '2rem solid #e9e9e9',
  borderTop: '2rem solid #8129b4',
  justify: 'center',
  borderRadius: '50%',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  boxSizing: 'border-box',
};

const spinTransition = {
  loop: Infinity,
  ease: 'linear',
  duration: 3,
};

const labelStyle = {
  margin: 0,
  padding: 0,
  lineHeight: 1,
};

export default function Loading() {
  const isTablet = useMediaQuery('(max-width: 992px)');

  return (
    <div style={isTablet ? containerStyleMobile : containerStyle}>
      <p style={labelStyle}>Loading...</p>
      <motion.span style={circleStyle} animate={{rotate: 360}} transition={spinTransition} />
    </div>
  );
}
